export default __webpack_public_path__ + "static/media/jsgamegif.348cadbe.gif";